import React, {
  useState,
  useRef,
} from "react";
import { withRouter } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {
  LOGIN_GET,
  VCODE_GET
} from "config/url";
import Typography from "@material-ui/core/Typography";
import { HookFormContent } from "components";
import { InputAdornment } from "@material-ui/core";
import { useCurl } from "zh-common-modules";
import { setStorage } from "utils";

const useStyles = makeStyles(theme => ({
  form: {
    paddingLeft: 100,
    flexBasis: 700,
    paddingRight: 100,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  }
}));

const MD5Crypt = (str) => new Promise((res, rej) => {
  import("crypto-js/md5").then(({default : MD5}) => {
    const cryptoStr = MD5(str).toString();
    res(cryptoStr);
  }).catch(e => {
    rej(e);
  })
})

export default withRouter(function SignInForm(props) {
  const { curl, fetching } = useCurl(false);
  const [ captchaUrl, setCaptchaUrl ] = useState(VCODE_GET);
  const { history, title } = props;
  const classes = useStyles();
  const loginMission = useRef();
  const formContext = useForm({
    mode: "onBlur"
  });
  const { handleSubmit } = formContext;
  const handleSignIn = (data) => {
    MD5Crypt(data.password).then(password => {
      data.password = password;
      loginMission.current = curl.get(LOGIN_GET, data)
        .then(res => {
          setStorage(res);
          history.push("/");
        })
    })
  };

  const changeCaptchaUrl = () => {
    const params = Math.random();
    setCaptchaUrl(`${captchaUrl}?${params}`);
  }

  const formSchema = [
    {
      value: "", name: "username", label: "用户名", type: "input", validate: {
        required: "用户名不能为空"
      }, variant: "outlined"
    },
    {
      value: "", name: "password", label: "密码", type: "password", validate: {
        required: "密码不能为空"
      }, variant: "outlined"
    },
    {
      value: "", name: "vcode", label: "验证码", type: "input", validate: {
        required: "验证码不能为空"
      }, variant: "outlined", InputProps : {
        endAdornment:
          <InputAdornment onClick={changeCaptchaUrl} position="end">
            <img alt="vcode" src={captchaUrl}/>
          </InputAdornment>
      }
    }
  ];

  const logining = fetching[loginMission.current];

  return (<form onSubmit={handleSubmit(handleSignIn)} className={classes.form}>
    {title && <Typography variant={"h6"}>
      {title}
    </Typography>}
    {formSchema.map((item, index) => {
      return <Box key={index} paddingTop={2}>
        <HookFormContent schema={item} formContext={formContext} />
      </Box>;
    })}
    <Box paddingTop={2}>
      <Button type="submit" variant="contained" disabled={logining} color="primary" fullWidth>{
        logining ? "登录中..." : "登录"
      }</Button>
    </Box>
  </form>);
});
